import type { AllRouteEndpoints } from "../routeTypes";
import { cacheKey as teamsData } from "../teamsData";
export const appsAppGroupIdTerritoryCreateCacheKeys: AllRouteEndpoints[] = [teamsData];
